import { useState } from 'react';
import NewsCard from './NewsCard';

export default function NewsGrid() {
  const [selectedCategory, setSelectedCategory] = useState('すべて');

  const categories = ['すべて', 'リリース', 'ライブ', 'メディア', 'その他'];

  const allNews = [
    {
      id: 1,
      date: '2024.03.20',
      category: 'リリース',
      title: '新シングル「夜空の向こう」配信開始',
      excerpt: '待望の新シングルがついにリリース。心に響くメロディーをお楽しみください。デジタル配信各サービスにて配信開始いたします。',
      image: 'https://readdy.ai/api/search-image?query=Professional%20recording%20studio%20session%20with%20musician%20holding%20acoustic%20guitar%20in%20intimate%20lighting%2C%20dark%20moody%20atmosphere%20with%20warm%20backlighting%20creating%20silhouettes%2C%20vintage%201970s%20aesthetic%20with%20psychedelic%20color%20tones%2C%20close-up%20composition%20focusing%20on%20upper%20body%20and%20guitar%2C%20artistic%20music%20photography%20with%20dramatic%20shadows%20and%20highlights&width=400&height=250&seq=news-1-v2&orientation=landscape',
      featured: true
    },
    {
      id: 2,
      date: '2024.03.18',
      category: 'ライブ',
      title: '春のアコースティックツアー開催決定',
      excerpt: '全国5都市を巡るアコースティックツアーの開催が決定しました。チケット先行販売は3月25日より開始予定です。',
      image: 'https://readdy.ai/api/search-image?query=Intimate%20acoustic%20concert%20venue%20with%20guitarist%20performing%20on%20stage%2C%20warm%20atmospheric%20stage%20lighting%20creating%20dramatic%20silhouettes%2C%20vintage%20concert%20hall%20with%20moody%20dark%20background%20and%20golden%20backlighting%2C%201970s%20psychedelic%20aesthetic%20with%20artistic%20lighting%20effects%2C%20close-up%20view%20of%20performer%20with%20guitar&width=400&height=250&seq=news-2-v2&orientation=landscape',
      featured: true
    },
    {
      id: 3,
      date: '2024.03.15',
      category: 'メディア',
      title: 'ラジオ番組「月ヶ瀬なつの　Friday Night Chatting ! (2025.12.5, 12.12, 12.19, 12.26放送回)」出演',
      excerpt: '月ヶ瀬なつのさんがパーソナリティを務める池袋FMラジオ番組に、ゲスト出演しました。',
      image: 'https://readdy.ai/api/search-image?query=Professional%20radio%20studio%20with%20musician%20holding%20guitar%20during%20interview%2C%20dark%20atmospheric%20lighting%20with%20warm%20backlighting%20creating%20artistic%20silhouettes%2C%20vintage%201970s%20broadcast%20studio%20aesthetic%20with%20moody%20shadows%2C%20intimate%20close-up%20composition%20focusing%20on%20upper%20body%20and%20guitar%2C%20psychedelic%20color%20tones%20with%20dramatic%20lighting&width=400&height=250&seq=news-3-v2&orientation=landscape'
    },
    {
      id: 4,
      date: '2024.03.12',
      category: 'リリース',
      title: 'アルバム「Memories」リマスター版発売決定',
      excerpt: 'デビューアルバムのリマスター版が発売決定。未発表楽曲2曲を含む特別仕様でお届けします。',
      image: 'https://readdy.ai/api/search-image?query=Vintage%20music%20album%20recording%20session%20with%20musician%20embracing%20acoustic%20guitar%2C%20dark%20moody%20studio%20atmosphere%20with%20warm%20backlighting%20creating%20dramatic%20silhouettes%2C%201970s%20psychedelic%20aesthetic%20with%20retro%20color%20tones%2C%20close-up%20artistic%20composition%20focusing%20on%20upper%20body%20and%20guitar%2C%20nostalgic%20music%20photography%20with%20atmospheric%20shadows&width=400&height=250&seq=news-4-v2&orientation=landscape'
    },
    {
      id: 5,
      date: '2024.03.10',
      category: 'ライブ',
      title: '東京公演追加開催のお知らせ',
      excerpt: 'ご好評につき東京公演の追加開催が決定いたしました。詳細は後日発表いたします。',
      image: 'https://readdy.ai/api/search-image?query=Tokyo%20concert%20hall%20with%20guitarist%20performing%20under%20dramatic%20stage%20lighting%2C%20dark%20atmospheric%20venue%20with%20warm%20backlighting%20creating%20artistic%20silhouettes%2C%20vintage%201970s%20concert%20aesthetic%20with%20psychedelic%20lighting%20effects%2C%20close-up%20view%20of%20performer%20holding%20guitar%2C%20moody%20concert%20photography%20with%20golden%20highlights&width=400&height=250&seq=news-5-v2&orientation=landscape'
    },
    {
      id: 6,
      date: '2024.03.08',
      category: 'メディア',
      title: '音楽雑誌「Sound Wave」インタビュー掲載',
      excerpt: '音楽雑誌「Sound Wave」4月号にインタビューが掲載されます。創作活動について詳しく語っています。',
      image: 'https://readdy.ai/api/search-image?query=Professional%20music%20magazine%20photo%20shoot%20with%20musician%20holding%20acoustic%20guitar%2C%20dark%20atmospheric%20studio%20lighting%20with%20warm%20backlighting%20creating%20dramatic%20silhouettes%2C%20vintage%201970s%20portrait%20photography%20aesthetic%20with%20psychedelic%20color%20tones%2C%20intimate%20close-up%20composition%20focusing%20on%20upper%20body%20and%20guitar%2C%20artistic%20music%20journalism%20photography&width=400&height=250&seq=news-6-v2&orientation=landscape'
    },
    {
      id: 7,
      date: '2024.03.05',
      category: 'その他',
      title: '公式グッズ新商品発売開始',
      excerpt: 'ファンの皆様からのご要望にお応えして、新しいグッズラインナップを発売開始いたします。',
      image: 'https://readdy.ai/api/search-image?query=Music%20merchandise%20display%20with%20vintage%20aesthetic%2C%20dark%20moody%20background%20with%20warm%20atmospheric%20lighting%2C%201970s%20psychedelic%20design%20elements%2C%20artistic%20product%20photography%20with%20dramatic%20shadows%20and%20highlights%2C%20retro%20music%20memorabilia%20with%20guitar%20silhouettes%2C%20close-up%20composition%20with%20artistic%20lighting%20effects&width=400&height=250&seq=news-7-v2&orientation=landscape'
    },
    {
      id: 8,
      date: '2024.03.03',
      category: 'ライブ',
      title: 'ファンクラブ限定ライブ開催決定',
      excerpt: 'ファンクラブ会員限定の特別ライブを開催いたします。アコースティック編成での特別な夜をお届けします。',
      image: 'https://readdy.ai/api/search-image?query=Intimate%20acoustic%20concert%20in%20small%20venue%20with%20guitarist%20performing%2C%20warm%20atmospheric%20lighting%20creating%20dramatic%20silhouettes%2C%20dark%20moody%20background%20with%20golden%20backlighting%2C%20vintage%201970s%20concert%20aesthetic%20with%20psychedelic%20lighting%20effects%2C%20close-up%20view%20of%20performer%20embracing%20guitar%2C%20special%20fan%20event%20photography&width=400&height=250&seq=news-8-v2&orientation=landscape'
    },
    {
      id: 9,
      date: '2024.03.01',
      category: 'メディア',
      title: 'テレビ番組「Morning Music」出演',
      excerpt: '3月15日放送のテレビ番組「Morning Music」に出演いたします。新曲の生演奏もお楽しみください。',
      image: 'https://readdy.ai/api/search-image?query=Television%20studio%20with%20musician%20holding%20acoustic%20guitar%20during%20live%20performance%2C%20dark%20atmospheric%20TV%20studio%20lighting%20with%20warm%20backlighting%20creating%20artistic%20silhouettes%2C%20vintage%201970s%20broadcast%20aesthetic%20with%20psychedelic%20color%20tones%2C%20close-up%20composition%20focusing%20on%20upper%20body%20and%20guitar%2C%20dramatic%20studio%20photography%20with%20moody%20shadows&width=400&height=250&seq=news-9-v2&orientation=landscape'
    }
  ];

  const filteredNews = selectedCategory === 'すべて' 
    ? allNews 
    : allNews.filter(news => news.category === selectedCategory);

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-4 mb-16">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-6 py-3 rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                selectedCategory === category
                  ? 'bg-black text-white shadow-lg'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Featured News */}
        {selectedCategory === 'すべて' && (
          <div className="mb-20">
            <h2 className="text-3xl font-bold mb-8 text-center">注目のニュース</h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
              {allNews.filter(news => news.featured).map((news) => (
                <NewsCard key={news.id} news={news} featured />
              ))}
            </div>
          </div>
        )}

        {/* All News Grid */}
        <div className="mb-8">
          <h2 className="text-3xl font-bold mb-8 text-center">
            {selectedCategory === 'すべて' ? 'すべてのニュース' : `${selectedCategory}のニュース`}
          </h2>
          <div className="text-center text-gray-600 mb-8">
            {filteredNews.length}件のニュースがあります
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {filteredNews.map((news) => (
            <NewsCard key={news.id} news={news} />
          ))}
        </div>

        {filteredNews.length === 0 && (
          <div className="text-center py-20">
            <i className="ri-newspaper-line text-6xl text-gray-300 mb-4"></i>
            <p className="text-xl text-gray-500">該当するニュースがありません</p>
          </div>
        )}
      </div>
    </section>
  );
}
